import { render, staticRenderFns } from "./UserL_List.vue?vue&type=template&id=c11ca584"
import script from "./UserL_List.vue?vue&type=script&lang=js"
export * from "./UserL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports